var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-tab-item",class:[{ 'nav-tab-item--active': _vm.active }, `nav-tab-item--${_vm.view}`]},[_c(_vm.tag,{tag:"component",staticClass:"nav-tab-item__link",attrs:{"to":_vm.to},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }